var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoorahHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_253_13789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.572 1.71436H3.42913C2.48236 1.71436 1.71484 2.48188 1.71484 3.42864V20.5715C1.71484 21.5183 2.48236 22.2858 3.42913 22.2858H20.572C21.5188 22.2858 22.2863 21.5183 22.2863 20.5715V3.42864C22.2863 2.48188 21.5188 1.71436 20.572 1.71436Z",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3825 6.42847C9.97809 6.42847 9.65021 6.75634 9.65021 7.16078V9.64903H7.162C6.75756 9.64903 6.42969 9.9769 6.42969 10.3814V13.6185C6.42969 14.023 6.75756 14.3508 7.162 14.3508H9.65021V16.839C9.65021 17.2434 9.97809 17.5713 10.3825 17.5713H13.6197C14.0241 17.5713 14.352 17.2434 14.352 16.839V14.3508H16.8402C17.2446 14.3508 17.5725 14.023 17.5725 13.6185V10.3814C17.5725 9.9769 17.2446 9.64903 16.8402 9.64903H14.352V7.16078C14.352 6.75634 14.0241 6.42847 13.6197 6.42847H10.3825Z",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_253_13789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoorahHealth);
export default __webpack_public_path__ + "static/media/shoorahHealth.dcad0d4f2c64ef915baa0a230cfed4e4.svg";
export { ForwardRef as ReactComponent };